import React, { useState, useEffect, useCallback } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import Select from "components/select";
import { useLoadingContext } from "components/loading-spinner-overlay";
import { getLogLevels, getCurrentLogLevel, changeLogLevel } from "./operations";
import FormConfirm from "components/form/form-confirm";
import styles from "./styles/change-log-level.css.js";
import withStyles from "components/with-styles";
import { useAuthDataContext } from "components/auth";

const ChangeLogLevelPage = ({ intl, classes }) => {
  const [availableLogLevels, setAvailableLogLevels] = useState([]);
  const [logLevel, setLogLevel] = useState();
  const [success, setSuccess] = useState(false);
  const { setLoading } = useLoadingContext();
  const [showConfirm, setShowConfirm] = useState(false);
  const { token } = useAuthDataContext();

  useEffect(
    () => {
      setLoading(true);
      Promise.all([getLogLevels(token), getCurrentLogLevel(token)])
        .then(([logLevels, current]) => {
          setAvailableLogLevels(logLevels);
          setLogLevel(current);
        })
        .finally(() => setLoading(false));
    },
    [setLoading, token],
  );

  const handleCloseConfirm = useCallback(() => setShowConfirm(false), []);

  const handleChange = ({ target: { value } }) => {
    setLogLevel(value);

    setLoading(true);
    const updatedData = changeLogLevel(value, token);

    return updatedData
      .then(result => setSuccess(Boolean(result)))
      .catch(() => {
        setSuccess(false);
      })
      .finally(() => {
        setShowConfirm(true);
        setLoading(false);
      });
  };

  return (
    <Dashboard>
      <FormConfirm
        autoHideDuration={2000}
        className={classes.confirm}
        show={showConfirm}
        error={!success}
        onClose={handleCloseConfirm}
        label={
          success
            ? intl.formatMessage({ id: "app.page.logger.success" })
            : intl.formatMessage({ id: "app.page.logger.error" })
        }
      />
      <PageHeaderBar title="app.page.logger" />
      <PageSection>
        <Select
          elements={availableLogLevels}
          id="logLevel"
          name="logLevel"
          getLabelFromElement={element => element}
          label={intl.formatMessage({ id: "app.page.logger.level" })}
          value={logLevel}
          onChange={handleChange}
        />
      </PageSection>
    </Dashboard>
  );
};

export default withStyles(styles)(ChangeLogLevelPage);
